import { isOpenEndedPhaseDuration } from '@sequencehq/utils'

import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { CubeStatus } from 'Cube/domain/cube.domain.types'
import { quoteStatusAdapter } from 'Cube/utils/status.adapter'

/**
 * True when this phase is open ended and the quote is set to leave open ended phases out of the
 * rendered document. Always false for billing schedules, which have no presentation settings.
 */
export const useOpenEndedPhaseHidden = (props: {
  phaseId: string
}): boolean => {
  const cubeContext = useCubeContext()

  const status = cubeContext.queries.rawData.data.common.status
  const isAQuoteOrTemplate =
    Boolean(quoteStatusAdapter.out(status)) ||
    status === CubeStatus.QuoteTemplate

  const isOpenEnded = isOpenEndedPhaseDuration(
    cubeContext.queries.resolvedPhases[props.phaseId]?.dates.duration
  )

  /**
   * Quotes that skip the presentation upgrade (accepted, executed) keep their original shape,
   * which may carry no settings at all.
   */
  const hideOpenEndedPhases = Boolean(
    cubeContext.queries.rawData.data.presentation.settings?.hideOpenEndedPhases
  )

  return isAQuoteOrTemplate && isOpenEnded && hideOpenEndedPhases
}
